import { render, staticRenderFns } from "./AddHeadingBlockModal.vue?vue&type=template&id=7ba5eb65&lang=pug&"
import script from "./AddHeadingBlockModal.vue?vue&type=script&lang=js&"
export * from "./AddHeadingBlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports